import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container">
        <Link className="navbar-brand" to="/" style={{ color: 'gold', fontWeight: 'bold' }}>WintonCoin</Link>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/tasks">Tareas</Link>
            </li>
            {currentUser && (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/my-tasks">Mis Tareas</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/messages">Mensajes</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/chat">Chat</Link>
                </li>
                {currentUser && currentUser.role === 'admin' && (
                  <li className="nav-item">
                    <Link className="nav-link" to="/chat-test">
                      <span className="badge bg-info">Prueba de Chat</span>
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
          
          <ul className="navbar-nav">
            {currentUser ? (
              <>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {currentUser.name}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <Link className="dropdown-item" to="/profile">Mi Perfil</Link>
                    </li>
                    <li>
                      <div className="dropdown-item token-display">
                        <span className="token-blue">{currentUser.tokensBlue || 0} BLUE</span>
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-item token-display">
                        <span className="token-red">{currentUser.tokensRed || 0} RED</span>
                      </div>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/dashboard">
                        <i className="fas fa-tachometer-alt me-2"></i>
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/wallet">
                        <i className="fas fa-wallet me-2"></i>
                        Mi Billetera
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/messages">
                        <i className="fas fa-comments me-2"></i>
                        Mensajes
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Cerrar Sesión
                      </button>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/login">Iniciar Sesión</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/register">Registrarse</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
